import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderManualPaymentsApi, OrderManualPaymentsDTO } from '@reposit/api-client';
import { AxiosResponse } from 'axios';
import { getErrorMessage } from '../../utils/common.utils';
import { AppState } from '../root.reducer';
import { createStandardOrderManualPaymentsApi, runThunkWithAuth } from '../utils/api.utils';
import { FetchClaimManualPaymentsPayload } from './manual-payments.types';

export const fetchClaimManualPaymentsThunk = createAsyncThunk<
  OrderManualPaymentsDTO,
  FetchClaimManualPaymentsPayload,
  {
    state: AppState;
    rejectValue: string;
  }
>('manual-payments/fetch-by-claim', async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  const dispatch = thunkAPI.dispatch;

  try {
    const api: OrderManualPaymentsApi = createStandardOrderManualPaymentsApi(state, dispatch);
    const apiResponse: AxiosResponse<OrderManualPaymentsDTO> = await runThunkWithAuth(
      () => api.getOrderManualPaymentsByClaim(payload.claimId),
      dispatch,
    );
    return apiResponse.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(getErrorMessage(e));
  }
});
